import React, { FC } from 'react';
import Snackbar, { SnackbarOrigin } from '@material-ui/core/Snackbar';
import MuiAlert, { Color } from '@material-ui/lab/Alert';

export interface IToastProps {
  message?: string;
  show: boolean;
  severity?: Color;
  autoHideDuration?: number;
  vertical?: SnackbarOrigin['vertical'];
  horizontal?: SnackbarOrigin['horizontal'];
  onClose?: () => void;
}

const Toast: FC<IToastProps> = (props) => {
  const {
    message,
    severity = 'info',
    autoHideDuration = 5000,
    show,
    vertical = 'bottom',
    horizontal = 'center',
    onClose,
  } = props;

  const handleClose = (event: React.SyntheticEvent, reason: string) => {
    if (reason === 'clickaway') {
      return;
    }

    if (onClose) onClose();
  };

  return (
    <Snackbar
      open={show}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical, horizontal }}
    >
      <MuiAlert elevation={6} variant="filled" severity={severity}>
        {message}
      </MuiAlert>
    </Snackbar>
  );
};

export default Toast;
